import { IGetAllClienteArquivoUseCase } from "../../../presentation/useCases/read/get_all_cliente_arquivo_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";
import { ClienteArquivoLista } from "../../models/clienteArquivoLista";
import { Paginated } from "../../../../../common/domain/models/paginated_models";

/**
 * GetAllClienteArquivoUseCase
 */

export class GetAllClienteArquivoUseCase extends BasePaginatedUseCase<ClienteArquivoLista> implements IGetAllClienteArquivoUseCase {
  constructor(private readonly repository: IComercialRepository) {
    super();
  }

  async execute(
    idCliente: number,
    currentPage?: number,
    rowsPerPage?: number
  ): Promise<void> {

    const response = await this.repository.getAllClienteArquivoLista(
      idCliente,
      currentPage,
      rowsPerPage
    );

    this._items = response.items;
    this._pageSize = response.pageSize;
    this._currentPage = response.currentPage;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;

  }
}
